/*----------------------------------
商品（コレクション）一覧ページのJS
------------------------------------*/

//商品画像ホバー時に2番目の画像

document.addEventListener('DOMContentLoaded', function () {
    var mediaHoverElements = document.querySelectorAll('.media--hover-effect');

    mediaHoverElements.forEach(function (element) {
        element.addEventListener('mouseenter', function () {
            var subFeaturedImage = element.querySelector('.sub-featured--image');
            if (subFeaturedImage) {
                subFeaturedImage.style.opacity = 1; // 透明度を1にしてフェードイン
            }
        });

        element.addEventListener('mouseleave', function () {
            var subFeaturedImage = element.querySelector('.sub-featured--image');
            if (subFeaturedImage) {
                subFeaturedImage.style.opacity = 0;
            }
        });
    });

    return false;
});

//モデル画像ホバー時に2番目の画像切り替え
document.addEventListener('DOMContentLoaded', function() {
    var modelHoverEffect = document.querySelector('.model--hover-effect');
    var subModelImage = document.querySelector('.sub-model--image');

    modelHoverEffect.addEventListener('mouseenter', function() {
        subModelImage.style.opacity = '1';
    });

    modelHoverEffect.addEventListener('mouseleave', function() {
        subModelImage.style.opacity = '0';
    });
});



//商品カード情報枠の高さを揃える
window.addEventListener('DOMContentLoaded', function () {
    function adjustItemHeights() {
    const items = document.querySelectorAll('.custom-collection-template__item__information');
    let maxHeight = 0;

    items.forEach(function (item) {
        item.style.height = 'auto'; // Reset the height to auto to recalculate.
        const height = item.clientHeight;
        maxHeight = Math.max(maxHeight, height);
    });

    items.forEach(function (item) {
        item.style.height = `${maxHeight}px`;
    });
    }

    // 最初に高さを揃える
    adjustItemHeights();

    // 画面サイズが変わるたびに高さを揃える
    window.addEventListener('resize', function () {
    adjustItemHeights();
    });
});

//フレーム２のフェードインアニメーション（タブレット・モバイル表示）
function fadeCollection() {
    var collectionElements = document.querySelectorAll('.collection-list__fadeinSp');
    var windowHeight = window.innerHeight;

    collectionElements.forEach(function (element) {
        var elementPosition = element.getBoundingClientRect().top;
        var scrollPosition = window.pageYOffset;

        if (scrollPosition >= elementPosition - windowHeight) {
            element.classList.add('fadeCollectionSp');
        } else {
            element.classList.remove('fadeCollectionSp');
        }
    });
}

function handleResize() {
    if (window.innerWidth <= 1022) {
        fadeCollection();
    } else {
        var collectionElements = document.querySelectorAll('.collection-list__fadeinSp');
        collectionElements.forEach(function (element) {
            element.classList.remove('fadeCollectionSp');
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    handleResize(); // ページ読み込み時に初回実行

    window.addEventListener('scroll', function () {
        fadeCollection();
    });

    window.addEventListener('resize', function () {
        handleResize(); // ウィンドウサイズが変更されたときに実行
    });
});



//フレーム２のフェードインアニメーション（PC表示）

document.addEventListener("DOMContentLoaded", function () {
    function fadeCollection() {
        var collectionElements = document.querySelectorAll('.collection-list__fadeinPC');
        var windowHeight = window.innerHeight;

        collectionElements.forEach(function (element) {
            var elementPosition = element.getBoundingClientRect().top;
            var scrollPosition = window.pageYOffset;

            if (scrollPosition >= elementPosition - windowHeight) {
                element.classList.add('fadeCollection');
                if (!element.hasAttribute('data-faded')) {
                    // アニメーションが終了したらborderを削除し、フラグを設定する
                    element.addEventListener('animationend', function() {
                        element.style.borderTop = 'none';
                        element.setAttribute('data-faded', 'true');
                    }, { once: true });
                }
            } else {
                element.classList.remove('fadeCollection');
                // スクロール位置がトップに戻ったらフラグを削除して元に戻す
                element.removeAttribute('data-faded');
                element.style.borderTop = '1px solid #888888';
            }
        });
    }
 
    window.addEventListener('scroll', function () {
        fadeCollection();
    });
});

